import React from "react";
import './BannerGilt.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function BannerGilt(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="BannerGilt">
            <div className="BannerGiltRight">
                <div className="BannerGiltTitle">
                    <TextSource ArrIndex= 'index0230'>Gilt-Edged Trading Conditions</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0235'>for Every Trader</TextSource>
                </div>
                <div className="BannerGiltText">
                <div className="BannerGiltTextIn">
                    <div className="BannerGiltText01">
                        <TextSource ArrIndex= 'index0240'>Execution in 0.2 seconds</TextSource>
                        <br/>
                        <TextSource ArrIndex= 'index0245'>New lower interbank spreads</TextSource>
                    </div>
                    <div className="BannerGiltText02">
                        <TextSource ArrIndex= 'index0250'>EUR/USD GBP/USD USD/JPY AUD/USD</TextSource>
                        <br/>
                        <TextSource ArrIndex= 'index0255'>0.7 pips 0.9 pips 0.8 pips 0.9 pips</TextSource>
                    </div>
                    <div className="BannerGiltButton ButtonOut">
                        <ChangeLink to={'/terms-of-trade'} lang={props.lang} style={{textDecoration: 'none'}}>
                            <div className='ButtonYellow'>
                                <TextSource ArrIndex= 'index0260'>FIND OUT MORE</TextSource>
                            </div>
                        </ChangeLink>
                    </div>
                </div>
                </div>

            </div>
                <div className="BannerGiltText03">
                    <TextSource ArrIndex= 'index0260'>Excluding ping time from your computer to out trading server/ Including 0.16 sec time for processing with liquidity Providers</TextSource>
                </div>
            </div>
    )}

export default BannerGilt





